import React from "react";
import { RichText } from "prismic-reactjs";
import renderButtons from "./../helpers/renderButtons";

export default function CTASlice(slice) {
  const backgroundStyle = {
    color: slice.primary.text_color,
    backgroundColor: slice.primary.background_color,
  };

  return (
    <section className="cta-slice section-padding" style={backgroundStyle}>
      <div className="wrapper">
        <div className="text-content">
          <RichText render={slice.primary.content} />
        </div>

        <div className="button-container">{renderButtons(slice.items)}</div>
        <div className="text-content-bottom">
          <RichText render={slice.primary.postscript_content} />
        </div>
      </div>
    </section>
  );
}
